// @flow

import React, { Component } from 'react';
import { find } from 'lodash';

import ChoiceList from 'web-ssr/app/common/components/ChoiceList';

import type { Node } from 'react';

type Props = {
  items: Array<*>,
  itemValueKey: string,
  className?: string,
  renderItem: (props: any) => Node,
  onChoose: (selectedItem: any) => void,
  ariaLabel?: string,
  getItemAriaLabel?: (props: any) => string,
};

type State = {
  highlightedItem: ?string,
};

class StatefulChoiceList extends Component<Props, State> {
  state = {
    highlightedItem: null,
  };

  onChoose = (selectedValue: string, isHardSelect?: boolean) => {
    const { itemValueKey } = this.props;

    if (!isHardSelect) {
      this.setState({
        highlightedItem: selectedValue,
      });
    } else {
      // Only allow the input through if there is a highlighted item, this
      // ensures the user explicitly selected an item, e.g. via hover or via
      // keyboard input
      if (this.state.highlightedItem) {
        const selectedItem = find(
          this.props.items,
          item => item && item[itemValueKey] === selectedValue
        );
        this.props.onChoose(selectedItem);
      }
    }
  };

  render() {
    const { onChoose } = this;
    const {
      items,
      renderItem,
      className,
      itemValueKey,
      ariaLabel,
      getItemAriaLabel,
    } = this.props;
    const { highlightedItem } = this.state;

    return (
      <ChoiceList
        ariaLabel={ariaLabel}
        className={className}
        getItemAriaLabel={getItemAriaLabel}
        Item={renderItem}
        items={items}
        itemValueKey={itemValueKey}
        onChoose={onChoose}
        value={highlightedItem}
      />
    );
  }
}

export default StatefulChoiceList;
